<template>
  <div class="container-fluid">
    <div class="mt-4">
      <Breadcrumb :breadcrumbs="breadcrumbs"/>

      <router-view v-if="isEnabled && $withPolicy('cm-taxas', 'viewer')"/>

      <div v-else>
        <h1>Aplicativo não habilitado</h1>
      </div>
    </div>
  </div>
</template>

<script>
  import BreadcrumbMixin from '@/mixins/BreadcrumbMixin'
  import Breadcrumb from '@/components/shares/Breadcrumb'
  import GetAccountApps from '@/mixins/GetAccountApps'

  export default {
    components: { Breadcrumb },
    computed: {
      isEnabled() {
        return this.activeAccountApps.some(aa => aa.name === 'cm-taxas')
      }
    },
    mixins: [BreadcrumbMixin, GetAccountApps],
    name: 'cm-taxas'
  }
</script>

<style scoped>

</style>
